import Link from "next/link";
import Image from "next/image";
import useTranslation from "next-translate/useTranslation";
import PlaySoundWithText from "@/components/home/HeroBanner/PlaySoundWithText";

const BecomeConsultantHero = () => {
  const { t } = useTranslation("become-consultant");

  return (
    <div className="bg-purple-800">
      <div className="container grid grid-cols-1 items-center justify-items-end gap-y-8 py-4 lg:grid-cols-2 lg:gap-x-6 lg:gap-y-28 lg:py-16">
        <div className="space-y-5 md:space-y-6 lg:space-y-6">
          <h1 className="first-line:text-gradient text-center font-title text-2xl font-bold md:text-3xl lg:text-left lg:text-6xl">{t`title`}</h1>
          <p className="text-center font-sans text-xs leading-5 text-grey-800 md:text-lg lg:text-left lg:text-xl lg:leading-[2.25rem]">{t`subtitle`}</p>
          <Link href="/register/start" passHref>
            <button type="button" className="button-lg hover-orange mx-auto block lg:mx-0">
              {t`start-now`}
            </button>
          </Link>
          <PlaySoundWithText
            sound="https://vialantis.fra1.cdn.digitaloceanspaces.com/static/sound/vialantis-berater.mp3"
            text="Was ist Vialantis? (52 Sek.)"
          />
        </div>
        <div className="relative order-first h-[300px] w-[327.44px] place-self-center lg:order-none lg:h-[503px] lg:w-[549px] lg:place-self-auto">
          <Image
            src="/become-consultant/hero.png"
            alt="People Connections"
            layout="fill"
            objectFit="cover"
            quality={100}
          />
        </div>
        <div className="col-span-full justify-self-center pt-10 text-center lg:pt-0">
          <h2 className="whitespace-pre-line text-center text-xl font-semibold lg:text-4xl">{t`for-whom-is-vialantis`}</h2>
          <div className="my-4 text-sm leading-5 text-grey-800 lg:my-16 lg:text-xl lg:leading-[2.25rem]">
            #Influenzer, #Therapeuten, #Coaches, #Kartenleger, #Psychologen, #Hellseher, #Yogalehrer, #Personaltrainer,
            #Musiklehrer, #Hebammen, #Autoren, #Schriftsteller, #Ernährungsberater, #Schamanen, #Traumdeuter, #Anwälte,
            #Ärzte, #Immobilienmakler, #Journalisten, #Heilpraktiker, #Hochzeitsplaner, #Steuerberater, #Pädagogen,
            #Nachhilfelehrer, #Theologen, #Künstler, #Fotografen, #Weltverbesserer u.v.a.m.
          </div>
        </div>
      </div>
    </div>
  );
};

export default BecomeConsultantHero;
